import dayjs from 'dayjs';
import * as React from 'react';

import { dayjst } from '@/lib/dayjst';

import { TableData } from './style';

interface DateHeaderProps {
  dateList: dayjs.Dayjs[];
}

const DateHeader: React.FC<DateHeaderProps> = React.memo(({ dateList }) => {
  return (
    <>
      {dateList.map(d => (
        <TableData
          key={`calender-${d.format('YYYYMMDD')}`}
          weekday={d.day()}
          isToday={d.isSame(dayjst(), 'day')}
        >
          <div>{d.format('D')}</div>
          <div>{d.format('dd')}</div>
        </TableData>
      ))}
    </>
  );
});

export default DateHeader;
